import http from './formalization.http';
import { DownloadDDCResponse } from './formalization.types';

export default {
  /**
   * Download the DDC file
   * @param financingId
   * @returns
   */
  downloadDDC: async (financingId: string): Promise<DownloadDDCResponse> => {
    const res = await http.get(`/v1/financings/credit-description/${financingId}?pdf=true`, {
      responseType: 'blob',
    });
    return res.data;
  },
};
